/**
 * Stichproben-Gate „Bereit"-Tab (T8, Plan-Zeile 137-144): „Alle freigeben" wird
 * erst aktiv, wenn mindestens `min(3, N)` Vorschläge einmal aufgeklappt wurden.
 * Reine Funktionen, damit die Gate-Logik ohne Component-Rendering testbar ist.
 */

/** Stichprobengröße: 3, oder weniger wenn insgesamt weniger Vorschläge vorliegen. */
export function sampleGateMin(total: number): number {
  return Math.min(3, total)
}

/** true sobald mindestens `sampleGateMin(total)` Vorschläge geprüft wurden. */
export function isGateOpen(checkedCount: number, total: number): boolean {
  return checkedCount >= sampleGateMin(total)
}
